import Util from '../../utilPc/';
import Events from '../../event/';
import { getTest } from './test';

const pcVideoUtil = new Util();

class RequestAd {
    constructor(opt, videoinfo) {
        this.type = opt.type;
        this.videoinfo = videoinfo;
        this.init(opt);
    }

    init(opt) {
        const videoinfo = this.videoinfo;

        this.adData = {
            frmid: opt.frmid, // 节目页面来源，免费底页为free,纪录片为vdocumentary
            catid: videoinfo.categoryId, // 分类ID
            ADOrderFirst: opt.ADOrderFirst || 0, // 播放技术重置，0或1
            ColumnName: videoinfo.columnName, // 栏目名称
            Actor: '',
            CreateDate: videoinfo.createdate, // 创建日期,需要添加
            Duration: videoinfo.duration, // 视频时长
            Keyword: videoinfo.keywords || videoinfo.keyword, // 关键字，需要添加
            adType: opt.adType, // 平台 0:定投广告 1:图文内页广告（组合传播播放器）2:专题广告（组合传播播放器）4:纪录片（底页播放器） 5:免费底页（底页播放器） 9:牛视（底页播放器）10:直播（直播播放器） 11.站外（站外播放器）
            subject: opt.subject || '',
            provider: videoinfo.CPId || '', // 内容提供商，需要添加
            // Vwidth: parseInt(pcVideoUtil.getStyle(document.getElementById(opt.containerDom)).width), // 播放器宽
            // Vheight: parseInt(pcVideoUtil.getStyle(document.getElementById(opt.containerDom)).height), // 播放器高
            id: videoinfo.vid,
            sid: pcVideoUtil.playerGetCookie('sid'),
            currentState: opt.type || 'head', // 当前请求的状态，head pause end
        };
        // console.log(this.adData, opt);

        if (typeof this.data == 'undefined') {
            // eslint-disable-line
            const adVHeader = new IfengAp();

            adVHeader.setPara(this.adData, this.request.bind(this));
        }
    }

    request = (obj) => {
        this.obj = obj;
        // 测试广告数据
        // this.obj = obj = getTest(this.type);

        this.data = {};

        if (obj.code === 0 || obj.info.length === 0) {
            return this.trigger('start', this.data, this.obj);
        }

        this.data = this.formatData(obj);

        return this.trigger('start', this.data, this.obj);
    };

    formatData(obj) {
        if (!obj || obj.code === 0 || obj.info.length === 0) return {};
        const _data = {};
        const frontAd = {};
        const behindAd = {};

        for (const i in obj.info) {
            const _obj = obj.info[i];

            switch (_obj.type) {
                // 前贴片
                case 1:
                    if (!frontAd.adUrl) {
                        frontAd.adUrl = [];
                    }
                    frontAd.adUrl.push(_obj.materialUrl);

                    if (!frontAd.clickUrl) {
                        frontAd.clickUrl = [];
                    }
                    frontAd.clickUrl.push(_obj.clickUrl);

                    if (!frontAd.adTime) {
                        frontAd.adTime = 0;
                    }
                    frontAd.adTime += parseInt(_obj.duration);

                    if (!frontAd.oneadTime) {
                        frontAd.oneadTime = [];
                    }
                    frontAd.oneadTime.push(_obj.duration);

                    if (!frontAd.vol) {
                        frontAd.vol = [];
                    }
                    if (_obj.vol === 0) {
                        _obj.vol = 0;
                    } else {
                        // 添加前贴片播放音量-没有则获取默认的
                        _obj.vol = _obj.vol || 0.42;
                    }
                    frontAd.vol.push(_obj.vol);

                    if (!frontAd.materialType) {
                        frontAd.materialType = [];
                    }
                    // materialType有三种类型：video img iframe，默认为video
                    frontAd.materialType.push(_obj.materialType || 'video');

                    if (!frontAd.materialWidth) {
                        frontAd.materialWidth = [];
                    }
                    frontAd.materialWidth.push(isNaN(parseInt(_obj.materialWidth)) ? 0 : parseInt(_obj.materialWidth));

                    if (!frontAd.materialHeight) {
                        frontAd.materialHeight = [];
                    }
                    frontAd.materialHeight.push(
                        isNaN(parseInt(_obj.materialHeight)) ? 0 : parseInt(_obj.materialHeight),
                    );

                    _data.frontAd = frontAd;
                    break;

                // 片头
                case 2:
                    if (!frontAd.adUrl) {
                        frontAd.adUrl = [];
                    }
                    frontAd.adUrl.push(_obj.materialUrl);

                    if (!frontAd.adTime) {
                        frontAd.adTime = 0;
                    }
                    frontAd.adTime += parseInt(_obj.duration);

                    if (!frontAd.oneadTime) {
                        frontAd.oneadTime = [];
                    }
                    frontAd.oneadTime.push(_obj.duration);

                    frontAd.clickUrl = [];

                    _data.frontAd = frontAd;
                    break;

                // 暂停广告
                case 3:
                    // 旧的
                    _data.materiaUrl = _obj.materialUrl;
                    _data.goUrl = _obj.clickUrl;
                    // 新的
                    _data.pause = {};
                    _data.pause.materialUrl = _obj.materialUrl;
                    _data.pause.materialType = _obj.materialType;
                    _data.pause.materialWidth = _obj.materialWidth;
                    _data.pause.materialHeight = _obj.materialHeight;
                    _data.pause.clickUrl = _obj.clickUrl;
                    break;

                // 角标广告
                case 4:
                    _data.corner = {};
                    _data.corner.imgUrl = _obj.materialUrl;
                    _data.corner.goUrl = _obj.clickUrl;
                    break;

                // banner广告
                case 5:
                    if (_data.banner) break;
                    _data.banner = {};
                    _data.banner.imgUrl = _obj.materialUrl;
                    _data.banner.goUrl = _obj.clickUrl;
                    break;

                // 后贴片
                case 9:
                    if (!behindAd.adUrl) {
                        behindAd.adUrl = [];
                    }
                    behindAd.adUrl.push(_obj.materialUrl);

                    if (!behindAd.clickUrl) {
                        behindAd.clickUrl = [];
                    }
                    behindAd.clickUrl.push(_obj.clickUrl);

                    if (!behindAd.adTime) {
                        behindAd.adTime = 0;
                    }
                    behindAd.adTime += parseInt(_obj.duration);

                    if (!behindAd.oneadTime) {
                        behindAd.oneadTime = [];
                    }
                    behindAd.oneadTime.push(_obj.duration);

                    if (!behindAd.vol) {
                        behindAd.vol = [];
                    }
                    if (_obj.vol === 0) {
                        _obj.vol = 0;
                    } else {
                        // 添加前贴片播放音量-没有则获取默认的
                        _obj.vol = _obj.vol || 0.42;
                    }
                    behindAd.vol.push(_obj.vol);

                    if (!behindAd.materialType) {
                        behindAd.materialType = [];
                    }
                    // materialType有三种类型：video img iframe，默认为video
                    behindAd.materialType.push(_obj.materialType || 'video');

                    if (!behindAd.materialWidth) {
                        behindAd.materialWidth = [];
                    }
                    behindAd.materialWidth.push(isNaN(parseInt(_obj.materialWidth)) ? 0 : parseInt(_obj.materialWidth));

                    if (!behindAd.materialHeight) {
                        behindAd.materialHeight = [];
                    }
                    behindAd.materialHeight.push(
                        isNaN(parseInt(_obj.materialHeight)) ? 0 : parseInt(_obj.materialHeight),
                    );

                    _data.behindAd = behindAd;
                    break;

                default:
                    break;
            }
        }

        return _data;
    }
}

Events.mixTo(RequestAd);
export default RequestAd;
